export const BILLING_WRITE = 'billing-write';
export const PARTNER_LEAD_REGISTRATION = 'partner-lead-registration';
export const DIRECTORY_USER = 'partner-join-program';
export const MARKETABLE_CONTACTS_WRITE = 'marketable-contacts-write';
export const MARKETABLE_CONTACTS_ACCESS = 'marketable-contacts-access';
export const CRM_ACCESS = 'crm-access';
export const CONTACTS_READ = 'contacts-read';